import { Routes } from '@angular/router';
import { SignUpVerifyPageComponent } from './pages/signup-verify/signup-verify.component';
import { ErrorComponent } from './pages/error/error.component';
import { SignUpVerifiedComponent } from './pages/signup-verified/signup-verified.component';
import { CompleteSignUpPageComponent } from './pages/complete-signup/complete-signup.component';
import { SignUpCompletedComponent } from './pages/signup-completed/signup-completed.component';

export const routes: Routes = [
  {
    path: 'signup',
    component: SignUpVerifyPageComponent,
    title: 'Aptem Assess Signup | Register',
  },
  {
    path: 'signup-verify',
    component: SignUpVerifiedComponent,
    title: 'Aptem Assess Signup | Verify',
  },
  {
    path: 'complete-signup',
    component: CompleteSignUpPageComponent,
    title: 'Aptem Assess Signup | Complete Registration',
  },
  {
    path: 'signup-completed',
    component: SignUpCompletedComponent,
    title: 'Aptem Assess Signup | Registration completed',
  },
  {
    path: '',
    redirectTo: 'signup',
    pathMatch: 'full',
  },
  {
    path: 'error',
    component: ErrorComponent,
    title: 'Aptem Assess Signup | Error',
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];
